module.exports = __webpack_public_path__ + "img/akar-icons_arrow-left.f4ece725.svg";